<ng-template #routerOutlet>
    <router-outlet></router-outlet>
</ng-template>

<layout *ngIf="activeLayout == 'layout'">
  <ng-container  *ngTemplateOutlet="routerOutlet" ></ng-container>

</layout>
<layout *ngIf="activeLayout == 'forum'" [menuVisible]="false" >
    <ng-container *ngTemplateOutlet="routerOutlet" ></ng-container>


</layout>
<dashlayout *ngIf="activeLayout == 'dashlayout'">
    <ng-container *ngTemplateOutlet="routerOutlet" ></ng-container>
</dashlayout>

<ng-container  *ngIf="activeLayout == 'authlayout'">
    <ng-container *ngTemplateOutlet="routerOutlet" ></ng-container>
</ng-container>
<loading *ngIf="loadingService.isLoading" mode="preload"></loading>
<app-api-switcher></app-api-switcher>

<!-- <div class="bg-overlay !fixed !z-[1000]" *ngIf="modalService.isModalVisible"></div> -->
